module.exports = __webpack_public_path__ + "static/media/ic-1.b5a10b71.svg";